import { useRef } from "react";

let counter = 0;

function nextId(): string {
  counter += 1;
  return `reports-uid-${counter}`;
}

export function useUniqueId(): string {
  const ref = useRef<string | null>(null);
  if (ref.current === null) {
    ref.current = nextId();
  }
  return ref.current;
}

export default useUniqueId;
